export var DEPLOY_DATE = new Date('2026-07-15T12:13:12+0000');
